/**
 * SPA-safe pageviews: history.pushState/replaceState patch (original first) +
 * popstate/hashchange. On URL change: page_left for the previous URL (active
 * time + max scroll), per-page resets, page_viewed for the new URL. Also runs
 * the pre-flush visibility hooks and emits page_left on pagehide — its
 * listeners register BEFORE startTransport's, so queued events make the flush.
 */
import { safe } from '../core/safe';
import { st } from '../core/state';
import { enqueue } from '../core/track';
import { getMaxScroll, getTimeOnPage, resetPage } from './activity';
import { doc, navH, on, visH } from './util';

let prevPath = '';
let prevHref = '';

function leave(): void {
	if (st.auto_.pageViews)
		enqueue('page_left', {
			path: prevPath,
			timeOnPageMs: getTimeOnPage(),
			maxScroll: getMaxScroll(),
		});
}

function view(): void {
	prevPath = location.pathname;
	prevHref = location.href;
	if (st.auto_.pageViews) enqueue('page_viewed');
}

const nav = safe(() => {
	if (location.href == prevHref) return;
	leave();
	for (const f of navH) f();
	resetPage();
	view();
});

export function initPageviews(): void {
	const H = history;
	for (const k of ['pushState', 'replaceState'] as const) {
		const o = H[k];
		H[k] = function (...a: Parameters<History['pushState']>) {
			const r = o.apply(this, a);
			nav();
			return r;
		};
	}
	for (const t of ['popstate', 'hashchange']) on(window, t, nav);
	on(doc, 'visibilitychange', () => {
		for (const f of visH) f(doc.hidden);
	});
	on(window, 'pagehide', () => {
		for (const f of visH) f(true, true);
		leave();
	});
	view();
}
